import { render, staticRenderFns } from "./PaymentView.vue?vue&type=template&id=89b78c7c&"
import script from "./PaymentView.vue?vue&type=script&lang=js&"
export * from "./PaymentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports